'use client';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { devQueryKeys, requestStableBuild } from '@/lib/api/dev/stable-build';
import type { StableBuildStatus } from '@/lib/schemas/dev/stable-build.schema';

// Demande de recompilation du frontend stable : l'état rendu par la route remplace le cache, ce
// qui relance le suivi rapproché de la recompilation.
export function useRequestStableBuild() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (): Promise<StableBuildStatus> => {
      const res = await requestStableBuild();
      if (!res.ok) throw new Error(res.messageKey);
      return res.status;
    },
    onSuccess: (status) => {
      queryClient.setQueryData(devQueryKeys.stableBuild(), status);
    },
  });
}
